import BlobMarketing2 from '@pkg/cms-icons/icons/bg_blob_marketing_2.svg?url';
import BlobMarketing3 from '@pkg/cms-icons/icons/bg_blob_marketing_3.svg?url';
import CalendarIcon from '@pkg/cms-icons/icons/Plan-Ahead_Icon.svg?url';
import ClockIcon from '@pkg/cms-icons/icons/TimeClock_Icon.svg?url';
import CrownIcon from '@pkg/cms-icons/icons/Crown.svg?url';
import DiamondIcon from '@pkg/cms-icons/icons/Diamond_Icon.svg?url';
import LocalHeroIcon from '@pkg/cms-icons/icons/LocalHero_Icon.svg?url';
import MagnifierIcon from '@pkg/cms-icons/icons/Magnifier_Icon.svg?url';
import RocketIcon from '@pkg/cms-icons/icons/Rocket.svg?url';
import SoldOutBagIcon from '@pkg/cms-icons/icons/SoldOutBag_Icon.svg?url';
import SparklesIcon from '@pkg/cms-icons/icons/Sparkles_Icon.svg?url';
import VeganIcon from '@pkg/cms-icons/icons/Vegan_Icon.svg?url';
import VegetarianIcon from '@pkg/cms-icons/icons/Vegetarian_Icon.svg?url';

/**
 * `default` is the beige blob, `unavailable` the neutral one and `urgent` the
 * red one, which also turns the icon red.
 */
export type TagIllustrationTone = 'default' | 'unavailable' | 'urgent';

export interface TagIllustration {
  icon: string;
  blob?: string;
  tone: TagIllustrationTone;
}

/**
 * Pop up illustration per API tag variant. A variant that is missing here, or
 * one the API adds later, renders the pop up without an illustration rather
 * than with an empty blob.
 */
export const TAG_ILLUSTRATIONS: Record<string, TagIllustration> = {
  SOLD_OUT: { icon: SoldOutBagIcon, blob: BlobMarketing2, tone: 'unavailable' },
  NOTHING_TO_SAVE_TODAY: { icon: SoldOutBagIcon, blob: BlobMarketing2, tone: 'unavailable' },
  ENDING_SOON: { icon: ClockIcon, blob: BlobMarketing2, tone: 'urgent' },
  SELLING_FAST: { icon: RocketIcon, blob: BlobMarketing2, tone: 'default' },
  POPULAR: { icon: CrownIcon, blob: BlobMarketing2, tone: 'default' },
  HIDDEN_GEM: { icon: DiamondIcon, blob: BlobMarketing2, tone: 'default' },
  LOCAL_HERO: { icon: LocalHeroIcon, tone: 'default' },
  RARE_FIND: { icon: MagnifierIcon, blob: BlobMarketing2, tone: 'default' },
  NEW: { icon: SparklesIcon, blob: BlobMarketing2, tone: 'default' },
  PLAN_AHEAD: { icon: CalendarIcon, blob: BlobMarketing2, tone: 'default' },
  VEGAN: { icon: VeganIcon, blob: BlobMarketing3, tone: 'default' },
  VEGETARIAN: { icon: VegetarianIcon, blob: BlobMarketing3, tone: 'default' },
};

export function getTagIllustration(tagVariant?: string): TagIllustration | undefined {
  return tagVariant ? TAG_ILLUSTRATIONS[tagVariant] : undefined;
}
